import React from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import styled from 'styled-components'
import Select from 'react-select'
import { FaSackDollar, FaCalculator } from 'react-icons/fa6'
import { FaUser } from 'react-icons/fa'
import CurrencyFormat from 'react-currency-format'
import ContentLoader from 'react-content-loader'
import { navigate } from 'raviger'

const NoData = styled.span`
  font-style: italic;
`

const DashboardStats = ({
  translate,
  locationOptions,
  selectedLocation,
  setSelectedLocation,
  loading,
  aggregatedData,
}) => {
  const isUSState = selectedLocation?.value?.startsWith('US-')
  const stateCode = isUSState ? selectedLocation.value.split('-')[1] : null

  const handleOrganizationClick = () => {
    if (stateCode) {
      navigate(`./search/advanced/programs?isNspaMember=true&orgState=${stateCode}`)
    }
  }

  const toWholeNumber = (value) => Math.round(Number(value))

  return (
    <>
      <Row className="mt-2 align-items-center">
        <Col md={1}>
          <SubHeader>{translate('landing_location')}</SubHeader>
        </Col>
        <Col md={4}>
          <Select
            options={locationOptions}
            value={selectedLocation}
            onChange={setSelectedLocation}
            placeholder={translate('view_member_map')}
            maxMenuHeight={400}
            styles={{
              menu: (provided) => ({
                ...provided,
                maxHeight: 400,
              }),
              menuList: (provided) => ({
                ...provided,
                maxHeight: 400,
              }),
            }}
          />
        </Col>
        <Col />
      </Row>
      <Row>
        {loading ? (
          <>
            <Col md={4}>
              <StyledCard>
                <Card.Body>
                  <ContentLoader
                    speed={2}
                    width="100%"
                    height={200}
                    viewBox="0 0 400 200"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100%" height="20" />
                    <circle cx="40" cy="70" r="30" />
                    <rect x="90" y="50" rx="3" ry="3" width="60%" height="40" />
                    <rect x="0" y="120" rx="3" ry="3" width="45%" height="30" />
                    <rect x="55%" y="120" rx="3" ry="3" width="45%" height="30" />
                  </ContentLoader>
                </Card.Body>
              </StyledCard>
            </Col>
            <Col md={4}>
              <StyledCard>
                <Card.Body>
                  <ContentLoader
                    speed={2}
                    width="100%"
                    height={200}
                    viewBox="0 0 400 200"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100%" height="20" />
                    <circle cx="40" cy="70" r="30" />
                    <rect x="90" y="50" rx="3" ry="3" width="60%" height="40" />
                    <rect x="0" y="120" rx="3" ry="3" width="45%" height="30" />
                    <rect x="55%" y="120" rx="3" ry="3" width="45%" height="30" />
                  </ContentLoader>
                </Card.Body>
              </StyledCard>
            </Col>
            <Col md={4}>
              <StyledCard>
                <Card.Body>
                  <ContentLoader
                    speed={2}
                    width="100%"
                    height={200}
                    viewBox="0 0 400 200"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100%" height="20" />
                    <circle cx="40" cy="70" r="30" />
                    <rect x="90" y="50" rx="3" ry="3" width="60%" height="40" />
                    <rect x="0" y="120" rx="3" ry="3" width="45%" height="30" />
                    <rect x="55%" y="120" rx="3" ry="3" width="45%" height="30" />
                  </ContentLoader>
                </Card.Body>
              </StyledCard>
            </Col>
          </>
        ) : (
          <>
            <Col md={4}>
              <StyledCard>
                <Card.Body>
                  <Row className="text-center font-weight-bold">
                    <Col>Total Dollars Available to Students</Col>
                  </Row>
                  <Row className="text-center m-3">
                    <Col md={1}>
                      <FaSackDollar color="rgb(242, 212, 90)" size={56} />
                    </Col>
                    <Col>
                      {aggregatedData?.awardAmount ? (
                        <CurrencyFormat
                          value={toWholeNumber(aggregatedData?.awardAmount)}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                        />
                      ) : (
                        <NoData>No Data Available</NoData>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center">
                      <div className="font-weight-bold">Program Count</div>
                      <div>
                        {aggregatedData?.programCount ? (
                          <CurrencyFormat
                              value={toWholeNumber(aggregatedData?.programCount)}
                            displayType={'text'}
                            thousandSeparator={true}
                          />
                        ) : (
                          <NoData>N/A</NoData>
                        )}
                      </div>
                    </Col>
                    <Col className="text-center">
                      <div className="font-weight-bold">Award Count</div>
                      <div>
                        {aggregatedData?.awardCount ? (
                          <CurrencyFormat
                            value={toWholeNumber(aggregatedData?.awardCount)}
                            displayType={'text'}
                            thousandSeparator={true}
                        />
                      ) : (
                        <NoData>N/A</NoData>
                      )}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </StyledCard>
            </Col>
            <Col md={4}>
              <StyledCard>
                <Card.Body>
                  <Row className="text-center font-weight-bold">
                    <Col>Average Award Amount</Col>
                  </Row>
                  <Row className="text-center m-3">
                    <Col md={2}>
                      <FaCalculator color="rgb(199, 123, 70)" size={56} />
                    </Col>
                    <Col md={10}>
                      {aggregatedData?.awardAmount ? (
                        <CurrencyFormat
                          value={toWholeNumber(
                            aggregatedData.awardAmount / aggregatedData.awardCount
                          )}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                        />
                      ) : (
                        <NoData>No Data Available</NoData>
                      )}
                    </Col>
                  </Row>
                  <Row className="text-center">
                    <Col>
                      <div className="font-weight-bold">Minimum Award</div>
                      <div>
                        {aggregatedData?.minAward ? (
                          <CurrencyFormat
                            value={toWholeNumber(aggregatedData?.minAward)}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />
                      ) : (
                        <NoData>N/A</NoData>
                      )}
                      </div>
                    </Col>
                    <Col>
                      <div className="font-weight-bold">Maximum Award</div>
                      <div>
                        {aggregatedData?.maxAward ? (
                          <CurrencyFormat
                            value={toWholeNumber(aggregatedData?.maxAward)}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                          />
                        ) : (
                          <NoData>N/A</NoData>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </StyledCard>
            </Col>
            <Col md={4}>
              <ClickableCard clickable={isUSState} onClick={handleOrganizationClick}>
                <Card.Body>
                  <Row className="text-center font-weight-bold">
                    <Col>Total Organizations</Col>
                  </Row>
                  <Row className="text-center m-3">
                    <Col md={2}>
                      <FaUser color="rgb(66, 100, 114)" size={56} />
                    </Col>
                    <Col md={10}>
                      {aggregatedData?.totalOrgCnt ? (
                        <CurrencyFormat
                          value={aggregatedData?.totalOrgCnt}
                          displayType={'text'}
                          thousandSeparator={true}
                        />
                      ) : (
                        <NoData>No Data Available</NoData>
                      )}
                    </Col>
                  </Row>
                  <Row className="text-center">
                    <Col>
                      <div className="font-weight-bold">NSPA Members</div>
                      <div>
                        {aggregatedData?.mbrCnt ? (
                          <CurrencyFormat
                            value={aggregatedData?.mbrCnt}
                            displayType={'text'}
                            thousandSeparator={true}
                          />
                        ) : (
                          <NoData>N/A</NoData>
                        )}
                      </div>
                    </Col>
                    <Col>
                      <div className="font-weight-bold">Non-Members</div>
                      <div>
                        {aggregatedData?.nonMbrCnt ? (
                          <CurrencyFormat
                            value={aggregatedData?.nonMbrCnt}
                            displayType={'text'}
                            thousandSeparator={true}
                          />
                        ) : (
                          <NoData>N/A</NoData>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </ClickableCard>
            </Col>
          </>
        )}
      </Row>
    </>
  )
}

const StyledCard = styled(Card)`
  transition: box-shadow 0.3s ease-in-out;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`

const ClickableCard = styled(Card)`
  transition: box-shadow 0.3s ease-in-out, transform 0.2s ease-in-out;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    ${({ clickable }) => clickable && 'transform: translateY(-2px);'}
  }
`

const SubHeader = styled.h5`
  color: ${({ theme }) => theme.palette.grayscale[2]};
  margin: 1rem 0;
  font-weight: bold;
`

export default DashboardStats
